import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { getEnv } from "@/env";
import { HttpMethods } from "@/react/http";
import { oktaTokenBaseQuery } from "@/react/services/api";

import computeDateRange from "./computeDateRange";
import { Recency } from "@/react/features/job-inventory/types";

const BASE_URL = `${getEnv("VUE_APP_API_V2_URL")}/v1/jobs-inventory`;

export const jobInventoryApi = createApi({
  reducerPath: "jobInventoryApi",
  baseQuery: oktaTokenBaseQuery({
    baseUrl: BASE_URL,
  }),
  endpoints: (build) => ({
    getFilteredJobs: build.query({
      query: ({ recency }) => {
        if (recency !== Recency.UNSET) {
          const { start, end } = computeDateRange(recency);
          return {
            method: HttpMethods.GET,
            url: `?start=${start}&end=${end}`,
          };
        }

        return {
          method: HttpMethods.GET,
        };
      },
    }),
    getJobDetails: build.query({
      query: ({ jobId }) => ({
        method: HttpMethods.GET,
        // NOTE: The encoding is here not to escape UUIDv4s (which have no
        // characters that need escaping). It's to prevent the user from
        // trying to access other URLs.
        url: `/${encodeURIComponent(jobId)}`,
      }),
    }),
  }),
});

export default jobInventoryApi;

export const { useLazyGetFilteredJobsQuery, useLazyGetJobDetailsQuery } =
  jobInventoryApi;
